import React, { useEffect, createRef, useState } from "react";
import clsx from "clsx";
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import BankIcon from '../icons/BankIcon';
import InsuranceCompaniesIcon from '../icons/InsuranceCompaniesIcon';
import InvestorsIcon from '../icons/InvestorsIcon';
import CorporationsIcon from '../icons/CorporationsIcon';
import Badge from '@material-ui/core/Badge';
import Tooltip from '@material-ui/core/Tooltip';
import translate from '../other/translate.json'
import { useHistory } from "react-router-dom";

export default function CardCatalog(props) {
	let language = localStorage.getItem('language') || 'Ru'
	const active = true
	const classes = useStyles();
	const navigate = useHistory();
	const refComponent = createRef();

	const [BriefDescription, _BriefDescription] = useState(props.body.slice(0, 150));
	const [count, _count] = useState(props.body?.length)

	let Icon1Vis = props.activeChips && props.activeChips.includes(5001) ? true : false
	let Icon2Vis = props.activeChips && props.activeChips.includes(5002) ? true : false
	let Icon3Vis = props.activeChips && props.activeChips.includes(5003) ? true : false
	let Icon4Vis = props.activeChips && props.activeChips.includes(5004) ? true : false

	useEffect(() => {
		const height = refComponent.current.getBoundingClientRect().height;

		if (height > 120) {
			_count(count - 1);
			_BriefDescription(BriefDescription.slice(0, count));
		}
	}, [refComponent]);

	const ellipsis = () => {
		if (BriefDescription?.length < props.body?.length) {
			return (
				<CustomTooltip title={props.body}><span style={{ textDecoration: 'underline' }}>...</span></CustomTooltip>
			)
		}
	}

	return (
		<StyledBadge badgeContent={props.badge} color="secondary">
			<Card className={classes.root}>
				<CardHeader className={classes.header} style={{ cursor: 'pointer' }} onClick={() => navigate.push(`/${props.catalog}/${props.link}/overview`)}
					avatar={
						<Avatar aria-label="recipe" className={classes.avatar} src={props.img} />
					}

					title={
						<Typography component="p" href={`/${props.catalog}/${props.link}/overview`} style={{ lineHeight: '21px', fontWeight: 'bold', textDecoration: 'none', color: '#000000' }}>
							{props.header}
						</Typography>
					}
				/>

				<CardContent className={classes.content} style={{ cursor: 'pointer' }} onClick={() => navigate.push(`/${props.catalog}/${props.link}/overview`)}>
					<Typography component="p" ref={refComponent} href={`/${props.catalog}/${props.link}/overview`} className={classes.contentBody}>
						{BriefDescription}{ellipsis()}
					</Typography>
				</CardContent>

				<CardActions disableSpacing className={classes.actions}>
					<CustomTooltip title={translate.Words[`labelBanks${language}`]}>
						<IconButton
							onClick={() => props.checkActiveChips(5001)}
							style={{ display: props.itemTags && props.itemTags.includes('5001') ? '' : 'none', padding: 0 }}
							aria-label="add to favorites"
							className={
								clsx(classes.iconBtn, {
									[classes.activeIconBtn]: active === Icon1Vis,
								})
							}
						>
							<BankIcon fill={'#FFFFFF'} />
						</IconButton>
					</CustomTooltip>

					<CustomTooltip title={translate.Words[`labelStrah${language}`]}>
						<IconButton
							onClick={() => props.checkActiveChips(5002)}
							style={{ display: props.itemTags && props.itemTags.includes('5002') ? '' : 'none', padding: 0 }}
							aria-label="Insurance Companies"
							className={
								clsx(classes.iconBtn, {
									[classes.activeIconBtn]: active === Icon2Vis,
								})
							}>
							<InsuranceCompaniesIcon fill={'#FFFFFF'} />
						</IconButton>
					</CustomTooltip>

					<CustomTooltip title={translate.Words[`labelInvest${language}`]}>
						<IconButton
							onClick={() => props.checkActiveChips(5003)}
							style={{ display: props.itemTags && props.itemTags.includes('5003') ? '' : 'none', padding: 0 }}
							aria-label={translate.Words[`labelInvest${language}`]}
							className={
								clsx(classes.iconBtn, {
									[classes.activeIconBtn]: active === Icon3Vis,
								})
							}>
							<InvestorsIcon fill={'#FFFFFF'} />
						</IconButton>
					</CustomTooltip>

					<CustomTooltip title={translate.Words[`labelCorp${language}`]}>
						<IconButton
							onClick={() => props.checkActiveChips(5004)}
							style={{ display: props.itemTags && props.itemTags.includes('5004') ? '' : 'none', padding: 0 }}
							aria-label="Corporations"
							className={
								clsx(classes.iconBtn, {
									[classes.activeIconBtn]: active === Icon4Vis,
								})
							}>
							<CorporationsIcon fill={'#FFFFFF'} />
						</IconButton>
					</CustomTooltip>
				</CardActions>
			</Card>
		</StyledBadge>
	);
}

const useStyles = makeStyles((theme) => ({
	root: {
		// maxWidth: 345,
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		borderRadius: theme.spacing(2),
		padding: theme.spacing(3),
		minHeight: 312,
		minWidth: 312,
		'&:hover': {
			boxShadow: '4px 4px 20px rgba(164, 163, 186, 0.7)',
		}
	},

	avatar: {
		backgroundColor: '#EBEEFF',
		height: 62,
		width: 62,
		borderRadius: 24,
		padding: 15
	},

	icon: {
		marginLeft: 8,
		backgroundColor: '#BCBBD0',
		'&:hover': {
			backgroundColor: '#BCBBD0',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	iconBtn: {
		marginLeft: 8,
		backgroundColor: '#dfdde8',
		width: 40,
		height: 40,
		'&:hover': {
			backgroundColor: '#dfdde8',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	activeIconBtn: {
		marginLeft: 8,
		backgroundColor: '#EB505E',
		width: 40,
		height: 40,
		'&:hover': {
			backgroundColor: '#EB505E',
		},
		'&:first-child': {
			marginLeft: 'auto',
		}
	},

	content: {
		height: 144,
		overflow: 'hidden',
		padding: '24px 0 0 0'
	},

	contentBody: {
		fontFamily: 'Cera CY',
		fontStyle: 'normal',
		fontWeight: 'normal',
		fontSize: '16px',
		lineHeight: '24px',
		color: '#8987A2',
		textDecoration: 'none'
	},

	header: {
		padding: 0,
		title: {
			fontSize: 22
		}
	},

	actions: {
		padding: '0',
		position: 'absolute',
		bottom: 24,
		right: 24
	},
}));

const StyledBadge = withStyles((theme) => ({
	badge: {
		right: 24,
		top: -10,
		// border: `2px solid ${theme.palette.background.paper}`,
		padding: '4px 8px',
		backgroundColor: '#FFF',
		color: '#8987A2',
		fontSize: 13,
		lineHeight: 16,
		transform: 'none',
		boxShadow: '4px 4px 10px rgba(164, 163, 186, 0.2)',
		height: 24,
		textAlign: 'center'
	},
}))(Badge);

const CustomTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: 'rgba(60, 60, 86, 0.8)',
		color: '#FFFFFF',
		boxShadow: 'none',
		padding: 12,
		borderRadius: 8,
		fontWeight: 'normal',
		fontSize: '12px',
		lineHeight: '14px',
	},
}))(Tooltip);
